<template lang="pug">
v-flex
  filtered-rates-info-modal(:value="displayFilteredRatesInfoModal" @close="displayFilteredRatesInfoModal = false")
  v-card.console-card.pb-4(ref="healthCard" height="100%")
    v-layout(column wrap)
      v-flex
        .headline.pb-3.font-weight-bold Messaging Health
        div.inline-content
          span Healthy opt-out rate: Below {{ optOutOkRate | percentageFormat }}
          v-tooltip(bottom max-width="250px")
            span(slot='activator')
              div.pl-2
                v-icon.tooltip-color.icon-margin-fix info_outlined
                span.tooltip-color What is opt-out rate?
            div
              div Opt-out Rate: (%) Shows how many contacts may not want to receive your texts. They may have unsubscribed or never opted-in in the first place.
              div Click “Get consent” below to have your recipients confirm their SMS consent. 
        div.inline-content
          span Healthy carrier filtered rate: Below {{ filteredOkRate | percentageFormat }}
          v-tooltip(bottom max-width="250px")
            span(slot='activator') 
              div.pl-2
                v-icon.tooltip-color.icon-margin-fix info_outlined
                span.tooltip-color What is carrier filtered rate?
            div
              div Carrier Filtered Rate: (%) Shows how many texts were blocked by mobile carriers because your messages were detected as spam.
              div Click “Learn to avoid carrier filtering” below to learn how to write texts that get delivered!
      v-divider.pb-1
      v-flex
        .pb-3.font-weight-bold Warning Records
        template(v-if="!isBlocked")
          div N/A
        template(v-else)
          div(v-for="rate in rates").error-color.pb-2
            div Date: {{ rate.start_date }}
            div Opt-out rate: {{ (rate.opt_out_rate_1 > optOutOkRate ? rate.opt_out_rate_1 : rate.opt_out_rate_2) | percentageFormat }}
            div Carrier filtered rate: {{ (rate.filtered_rate_1 > filteredOkRate ? rate.filtered_rate_1 : rate.filtered_rate_2) | percentageFormat }}
      v-divider.pb-1
      v-flex
        div(v-if="!isPermaBlocked")
          .pb-1.font-weight-bold Q: What can I do to improve my opt-out rate? Click below to have your contacts confirm their SMS consent.
          v-btn(color='primary' @click="goToEmail").mb-2 Get Consent
          .pb-1.font-weight-bold Q: What can I do to improve my carrier filtered rate? Click below to see guidelines on best texting practices to avoid carrier filtering.
          v-btn(color='primary' outline @click="displayFilteredRatesInfoModal = true").mb-2 Learn to avoid carrier filtering
          .pb-1.font-weight-bold Q: What happens if my rates don't improve?
          .pb-3 A: Continued high opt-out/filter rates might lead to loss of all texting capabilities.
        .pb-1.font-weight-bold Q: My texting has been disabled. How can I regain texting?
        .pb-1 A: Unfortunately, we cannot restore texting capabilities in LionDesk for suspended users due to regulatory requirements.
      </template>

<script>
import { createNamespacedHelpers } from 'vuex';
import FilteredRatesInfoModal from './FilteredRatesInfoModal.vue';

const { mapState: mapUserSmsErrorRatesState } =
  createNamespacedHelpers('userSmsErrorRates');
export default {
  name: 'MessagingHealth',
  components: { FilteredRatesInfoModal },
  data() {
    return {
      displayFilteredRatesInfoModal: false,
    };
  },
  mounted() {
    if (this.$route.hash === '#health') {
      setTimeout(() => {this.$refs.healthCard.$el.scrollIntoView({ behavior: "smooth", block: "start" })}, 100)
    }
  },
  computed: {
    ...mapUserSmsErrorRatesState([
      'optOutRate1',
      'filteredRate1',
      'optOutOkRate',
      'filteredOkRate',
      'isBlocked',
      'isLoading',
      'getRatesError',
      'isPermaBlocked',
      'rates',
    ]),
  },
  methods: {
    goToEmail() {
      this.$router.push('/communications/email#consent');
    },
  },
  filters: {
    percentageFormat(value) {
      return (value * 100).toFixed(1) + '%';
    },
  },
};
</script>

<style lang="scss" scoped>
.inline-content {
  display: flex;
}

.tooltip-color {
  color: var(--v-primary-base) !important
}

.error-color {
  color: var(--v-error-base) !important
}

.icon-margin-fix {
  margin-right: -20px;
}

.console-card {
  display: flex;
  flex-direction: row;
  padding: 32px;
}
</style>